<template>
  <div class="my-scenes-body">
    <div>
      <div class="message-head-body">
        <div>
          <a-checkbox
            :indeterminate="indeterminate"
            :checked="checkAll"
            @change="allChange"
          >
            已选：{{ selectNum }} 项
          </a-checkbox>
          <a-button class="btn-gray">批量删除</a-button>
        </div>
        <span>全部标为已读</span>
      </div>
      <div class="message-list-body">
        <div
          class="message-list"
          v-for="(item, index) in messageList"
          :key="index"
        >
          <span style="width: 30px"
            ><a-checkbox
              :checked="item.checked"
              :data-index="index"
              :value="index"
              @change="onChange"
          /></span>
          <div class="message-desc">
            <a-badge :count="item.read ? 0 : 1" dot>
              <img v-if="item.read" src="@/assets/img/yidu.png" />
              <img v-else src="@/assets/img/weidu.png" />
            </a-badge>
            <p>
              很遗憾，您揭榜的需求「知乎数据挖掘与内容监管平台」已定帅，您未中榜。
            </p>
            <span>查看详情 >></span>
          </div>
          <span class="message-date">2021-07-02 10:24</span>
          <span class="message-del">删除</span>
        </div>
      </div>
      <div class="message-page">
        <a-pagination
          show-quick-jumper
          show-size-changer
          :default-current="1"
          :total="50"
          :show-total="(total) => `共 ${total} 页`"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      indeterminate: false,
      checkAll: false,
      messageList: [
        {
          read: false,
          checked: false,
        },
        {
          read: true,
          checked: false,
        },
        {
          read: true,
          checked: false,
        },
        {
          read: false,
          checked: false,
        },
      ],
      selectNum: 0,
    };
  },
  methods: {
    onChange(e) {
      let index = e.target.value;
      let num = 0;
      let messageLength = this.messageList.length;
      this.messageList[index].checked = e.target.checked;
      this.messageList.forEach((element) => {
        if (element.checked) {
          num++;
        }
      });
      if (num != 0 && messageLength != num) {
        this.indeterminate = true;
        this.checkAll = false;
      } else if (num == 0) {
        this.indeterminate = false;
        this.checkAll = false;
      } else if (messageLength == num) {
        this.indeterminate = false;
        this.checkAll = true;
      }
      this.selectNum = num;
    },
    allChange(e) {
      let num = 0;
      this.checkAll = e.target.checked;
      this.messageList.forEach((element) => {
        element.checked = e.target.checked;
        if (element.checked) {
          num++;
        }
      });
      this.selectNum = num;
    },
  },
};
</script>

<style lang="less" scoped>
.my-scenes-body {
  background: #f5f5f5;
  height: 100%;
  overflow-y: auto;
  > div {
    width: 1240px;
    margin: 0 auto;
    .message-head-body {
      height: 48px;
      background: #fafafa;
      border-bottom: 1px solid #f0f0f0;
      padding: 0 48px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      > div {
        > button {
          margin-left: 10px;
        }
      }
      > span {
        color: #1abc9c;
        cursor: pointer;
      }
    }
    .message-list-body {
      background: #fff;
      padding: 0 24px;
      .message-list {
        padding: 30px 24px;
        border-bottom: 1px solid #f0f0f0;
        display: flex;
        align-items: center;
        .message-desc {
          width: 750px;
          display: flex;
          align-items: center;
          margin-right: 16px;
          img {
            display: block;
          }
          > p {
            margin-left: 16px;
          }
          > span {
            color: #1abc9c;
            cursor: pointer;
          }
        }
        .message-date {
          margin-right: 200px;
        }
        .message-del {
          color: #1abc9c;
          cursor: pointer;
        }
      }
    }
  }
}
.message-page {
  padding: 24px;
  text-align: right;
}
</style>
